// 🔹 SEO Configuration with Enhanced Local, Visual & Gen Z Optimization

export const businessData = {
  name: 'GiGi Hair Braiding',
  tagline: 'Professional Hair Braiding in Irvington, NJ',
  description:
    'Premium hair braiding services in Irvington, New Jersey. Expert braiding, protective styling, and natural hair care by GiGi. Book your appointment today.',
  phone: '(862) 235-0801',
  email: 'gigihairappointments@gmail.com',
  address: '329 16th Ave, Irvington, NJ 07111',
  city: 'Irvington',
  state: 'NJ',
  zip: '07111',
  coordinates: {
    latitude: 40.7218,
    longitude: -74.2543,
  },
  hours: {
    monday: '9:00 AM - 6:00 PM',
    tuesday: '9:00 AM - 6:00 PM',
    wednesday: '9:00 AM - 6:00 PM',
    thursday: '9:00 AM - 6:00 PM',
    friday: '9:00 AM - 6:00 PM',
    saturday: '9:00 AM - 6:00 PM',
    sunday: 'CLOSED',
  },
  social: {
    facebook: 'https://www.facebook.com/GiGiHaiRBraidinG',
    instagram:
      'https://www.instagram.com/gigihairbraiding/?igshid=OGQ5ZDc2ODk2ZA%3D%3D&utm_source=qr',
    tiktok: 'https://www.tiktok.com/@gigi.hair.braiding',
  },
};

// 🔸 Expanded Keyword Coverage
export const keywords = {
  primary: ['hair braiding', 'Irvington NJ', 'box braids', 'salon'],
  secondary: [
    'protective styling',
    'cornrows',
    'braiding services',
    'hair care',
    'New Jersey',
    'professional braiding',
  ],
  local: [
    'braiding near me',
    'hair salon Irvington',
    'box braids near Irvington',
    'professional braiding Irvington NJ',
  ],
  extra: [
    'knotless braids in Irvington NJ',
    'affordable box braids near Newark',
    'natural hair stylist near me',
    'feed-in cornrows Irvington',
    'boho braids in New Jersey',
    'kids braids salon Irvington',
    'men’s braids Newark area',
    'braiding shop open now Irvington',
    'best braider in Irvington NJ',
    'small knotless braids Newark',
  ],
};

// 🔹 Meta Tags with Open Graph & Twitter Support
export const metaTags = {
  home: {
    title: 'GiGi Hair Braiding | Knotless & Box Braids in Irvington, NJ',
    description:
      'Expert hair braiding in Irvington, NJ — specializing in knotless braids, box braids, and protective styles. Call (862) 235-0801 to book today.',
    keywords: [
      ...keywords.primary,
      ...keywords.secondary,
      ...keywords.local,
      ...keywords.extra,
    ].join(', '),
    openGraph: {
      title: 'GiGi Hair Braiding - Knotless & Box Braids in Irvington, NJ',
      description:
        'Protective styles, natural hair care, and trending braids by GiGi. Book your appointment today!',
      url: 'https://gigihairbraiding.com',
      image: 'https://gigihairbraiding.com/og-image.jpg',
      type: 'website',
    },
    twitter: {
      card: 'summary_large_image',
      title: 'GiGi Hair Braiding | Professional Braiding in Irvington NJ',
      description:
        'Protective styles, box braids, and cornrows for all textures. Follow @gigihairbraiding!',
      image: 'https://gigihairbraiding.com/og-image.jpg',
    },
  },
  services: {
    title: 'Our Services | GiGi Hair Braiding - Irvington, NJ',
    description:
      'Explore our hair braiding services — box braids, knotless styles, twists, cornrows, and more. Serving Irvington, NJ & Newark areas.',
    keywords:
      'braiding services, knotless braids, box braids, cornrows, twists, protective styling',
  },
  gallery: {
    title: 'Gallery | GiGi Hair Braiding - Irvington, NJ',
    description:
      'View our gallery of beautiful braiding work. See knotless, feed-in, and boho braids styled by GiGi in Irvington, NJ.',
    keywords:
      'braiding gallery, box braids photos, hair transformations, professional braiding work',
  },
  about: {
    title: 'About GiGi | Professional Hair Braiding in Irvington, NJ',
    description:
      'Learn about GiGi, her passion for protective styling, and her dedication to the Irvington community.',
    keywords:
      'about GiGi, hair braiding expert, Irvington NJ, natural hair care stylist',
  },
  contact: {
    title: 'Contact GiGi | Hair Braiding in Irvington, NJ',
    description:
      'Visit us at 329 16th Ave, Irvington, NJ. Book appointments online or call (862) 235-0801 today!',
    keywords:
      'contact GiGi, book appointment, Irvington NJ salon, braids near Newark',
  },
};

// 🔸 Structured Data with Offers, Reviews, and FAQs
export const generateStructuredData = () => ({
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  '@id': 'https://gigihairbraiding.com',
  name: businessData.name,
  image: 'https://gigihairbraiding.com/logo.png',
  description: businessData.description,
  address: {
    '@type': 'PostalAddress',
    streetAddress: businessData.address,
    addressLocality: businessData.city,
    addressRegion: businessData.state,
    postalCode: businessData.zip,
    addressCountry: 'US',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: businessData.coordinates.latitude,
    longitude: businessData.coordinates.longitude,
  },
  telephone: businessData.phone,
  url: 'https://gigihairbraiding.com',
  sameAs: [
    businessData.social.facebook,
    businessData.social.instagram,
    businessData.social.tiktok,
  ],
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
      ],
      opens: '09:00',
      closes: '18:00',
    },
  ],
  priceRange: '$$',
  makesOffer: [
    {
      '@type': 'Offer',
      itemOffered: {
        '@type': 'Service',
        name: 'Knotless Box Braids',
        description:
          'Lightweight, protective knotless braids for all hair types.',
      },
      priceCurrency: 'USD',
      price: '180',
    },
    {
      '@type': 'Offer',
      itemOffered: {
        '@type': 'Service',
        name: 'Feed-In Cornrows',
        description:
          'Natural cornrow styles for everyday wear or special occasions.',
      },
      priceCurrency: 'USD',
      price: '100',
    },
  ],
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.9',
    reviewCount: '135',
  },
  mainEntity: {
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'Where can I get box braids near Irvington NJ?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'GiGi Hair Braiding offers professional box braids and protective styles at 329 16th Ave, Irvington NJ. Call (862) 235-0801 to book your appointment.',
        },
      },
      {
        '@type': 'Question',
        name: 'How much do knotless braids cost in Irvington NJ?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Our knotless braids start at $180, depending on length and size. Book a consultation for custom pricing.',
        },
      },
    ],
  },
});
